import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import Millimetre from "../../../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function ElastischerBereichDerSeitlichenBettung({ elastischerBereichDerSeitlichenBettung = 0 }) {
  const { t } = useTranslation("translation");
  const w_y_Formula = `\\displaystyle w_{y} = k_{y} \\cdot D_{c}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.elasticSoilReaction")}</p>}
      indicesValue={
        <span>
          w<sub>y</sub>
        </span>
      }
      formulaValue={<ToolTip id={"w_y_Formula"} type={IconType.FORMULA} formula={w_y_Formula} />}
      inputValue={
        <span className="input">{ConvertToString(elastischerBereichDerSeitlichenBettung)}</span>
      }
      unitValue={<Millimetre />}
    />
  );
}

export default ElastischerBereichDerSeitlichenBettung;
